module.exports = __webpack_public_path__ + "static/media/bjjroll2.99a166a0.jpg";